import type { ApiResponse } from '@abaninja/types';

import { apiClient } from '@abaninja/util-http-client';
import { createCancellablePromise } from '@abaninja/util-store';

import type { Box, Section } from '../../@types';

export function getDeepBoxes(connectionUuid: string) {
  return createCancellablePromise(({ signal }) => apiClient.get<ApiResponse<Section[]>>(
    `/deep-cloud/v1/connections/${connectionUuid}/deepboxes`,
    { signal },
  ));
}

export function getDeepBoxBoxes(connectionUuid: string, deepBoxUuid: string) {
  return createCancellablePromise(({ signal }) => apiClient.get<ApiResponse<Box[]>>(
    `/deep-cloud/v1/connections/${connectionUuid}/deepboxes/${deepBoxUuid}/boxes`,
    { signal },
  ));
}
